import React  from 'react';
import cn from 'clsx';
import { ModalContent as FrontonModalContent } from 'fronton-react';
import { modalContent, modalContentContainer } from './modal-styles';

type ModalContentActionProps = {
  className?: string;
  children: React.ReactNode;
  variant?: 'simple';
}

export const ModalContent: React.FC<ModalContentActionProps> = ({ className, children, variant }) => (
  <FrontonModalContent className={cn(modalContent, className)}>
    <div className={cn({[modalContentContainer]: variant === 'simple'})}>{children}</div>
  </FrontonModalContent>
);
